export { default as default } from '../modules/react/Input.js'


//////////////////
// WEBPACK FOOTER
// ../input-format/react/index.js
// module id = 277
// module chunks = 0 1